import {useMemo} from "react";
import {useSelector} from "react-redux";
import {useFirestoreConnect} from "react-redux-firebase";
import {orderBy} from 'lodash'

export default function useStatistic(internalId) {

    const getRef = useSelector(state => state.firestore.ordered['stat_ref']);
    const firestoreState = useSelector(state => state.firestore.ordered);

    const statCollectionNames = useMemo(() => {
        return getRef ? (getRef[0].order || []) : []
    }, [getRef])

    const query = useMemo(() => {
        return statCollectionNames.map(name => ({
            collection: name,
            doc: internalId,
            storeAs: `${internalId}_${name}`
        }))
    }, [internalId, statCollectionNames])

    const queryResult = useMemo(() => {
        let list = []

        statCollectionNames.forEach(name => {
            const result = firestoreState[`${internalId}_${name}`] || [];
            list = [...list, ...result]
        })

        return orderBy(list, 'PeriodeDeb', 'desc')

    }, [firestoreState, internalId, statCollectionNames]);

    const loading = useMemo(() => {
        const keys = ['stat_ref', ...statCollectionNames.map(one => `${internalId}_${one}`)];
        let flag = false;
        keys.forEach(key => {
            if (!(key in firestoreState))
                flag = true;
        })
        return flag
    }, [firestoreState, internalId, statCollectionNames])

    useFirestoreConnect(() => [
        {
            collection: 'reference_stories',
            doc: 'statistiqueOrder',
            storeAs: 'stat_ref'
        },
        ...query
    ]);

    return {loading, list: queryResult}
}